import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "hearer - hover for icon",
  "use": "hearer - hover for icon-usage",
  "viewBox": "0 0 38 38",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 38 38\" id=\"hearer - hover for icon\">\n  <rect id=\"hearer - hover for icon_active\" width=\"38\" height=\"38\" rx=\"6\" fill=\"#6899b0\" opacity=\"0.001\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol